import React from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './GameStudio.module.scss';

function GameStudio({
  backGroundImage,
  title,
  paragraph,
  rightData,
  imageBack,
  onClick,
}) {
  const navigate = useNavigate();
  return (
    <div className={`${classes.lotteryStudio} ${classes[backGroundImage]}`}>
      <div className={`${classes.lotteryPosition} ${classes[rightData]}`}>
        <img
          src={imageBack}
          className={`${classes.imageStyle} ${classes[backGroundImage]}`}
        />
        <div className={classes.infoDetails}>
          <div className={`${classes.titleBtn} ${classes[rightData]}`}>
            <div>
              <span className={`${classes.titleStyle} ${classes[rightData]}`}>
                {title}
              </span>
            </div>
          </div>
          <div>
            <p className={`${classes.paragraphStyle} ${classes[rightData]}`}>
              {paragraph}
            </p>
            <div className={`${classes.btnPositions} ${classes[rightData]}`}>
              <button className={classes.btnStyle} onClick={onClick}>
                Web Games
              </button>
              <button
                className={classes.btnStyle + ' ' + classes.secondBtn}
                onClick={() => navigate('/ussdGames')}
              >
                USSD Games
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GameStudio;
